module.exports = __webpack_public_path__ + "img/ysy.bee1de16.png";